export const getAssetPath = (path: string): string =>
  import.meta.env.BASE_URL + path.replace(/^\//, '');
